<!-- 乘机人 列表 -->
<template>
  <div class="traver12306">
    <van-cell
      class="traver12306-hd"
      :title="title"
      :border="false"
    >
      <slot
        name="title"
        slot="title"
      />
      <span
        v-show="addButton"
        class="addCxr main-color"
        @click="$refs.traverList.toggle()"
      >
        添加 / 编辑乘客
      </span>
      <span
        v-show="addButton"
        class="addCxr main-color"
        @click="$refs.addChildren.toggle()"
        style="margin-left: 5px;"
      >
        + 加儿童
      </span>
    </van-cell>

    <div
      v-for="(psg, index) in travelerList"
      :key="index"
      class="traveler-item round-sm van-hairline--top"
    >
      <!-- 儿童 -->
      <van-row
        v-if="psg.psgType == 2"
        type="flex"
        align="center"
      >
        <van-col
          class="delete"
          @click="deletePsg(index)"
        >
          <ld-icon
            class="red"
            type="iconjianshao"
          />
        </van-col>

        <van-col class="info">
          <div class="font16 font-md">
            {{ psg.name }}
            <van-tag plain>
              {{ psg.psgType | passengerType }}
            </van-tag>
          </div>
          <div class="font12 gray mt5">
            使用{{ psg.name }}的证件取票
          </div>
        </van-col>
      </van-row>

      <!-- 成人 -->
      <van-row
        v-else
        type="flex"
        align="center"
      >
        <van-col
          class="delete"
          @click="deletePsg(index, psg)"
        >
          <ld-icon
            class="red"
            type="iconjianshao"
          />
        </van-col>

        <van-col class="info">
          <div class="font16 font-md">
            {{ psg.name }}
            <van-tag plain>
              {{ psg.psgType | passengerType }}
            </van-tag>
          </div>
          <div class="font12 gray mt5">
            <span>
              {{ psg.identyType | cardType }}
            </span>
            <span>
              {{ psg.identy }}
            </span>
            <div>{{ $t('F008','手机号') }}：{{ psg.phoneNumber }}</div>
          </div>
          <div
            v-if="psg.isNotAccount"
            class="font12 mt5"
          >
            <span class="red">乘客信息不存在12306常旅客中，请更换12306账号或添加常旅客</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <traver-list
      ref="traverList"
      :person-list="personList"
      :element="element"
      @selected="empCallBack"
    />

    <add-children
      ref="addChildren"
      :traveler-list="travelerList"
      @selected="addChildren"
    />
  </div>
</template>

<script>
import { Tag, Cell } from 'vant'
import { mapGetters } from 'vuex'

import traverList from './traverList.vue'
import addChildren from '../traver/addChildren.vue'

export default {
  name: 'Traver',
  components: {
    traverList,
    addChildren,
    [Cell.name]: Cell,
    [Tag.name]: Tag
  },
  props: {
    travelerList: {//需要展示的出行人
      type: [Array, Object],
      required: true,
      default: function() {
        return []
      }
    },
    personList:{ //出差申请单中乘机人集合
      type: [Array, Object],
      default: function() {
        return []
      }
    },
    title: {
      type: String,
      default: '乘机人'
    },
    disabled: {
      //禁止滑动
      type: Boolean,
      default: false
    },
    addButton: {
      //显示增加 按钮
      type: Boolean,
      default: true
    },
    storeName: {
      type: String,
      default: 'tr/travelerList'
    },
    element:{
      type:String,
      default:''
    },
  },
  data() {
    return {
      psgInfo: {},
    }
  },
  created() {
  },
  methods: {
    empCallBack(info) {
      this.$store.commit('tr/travelerList', info)
      this.$emit('match-clzc')
    },
    addChildren(psg, i) {
      this.$refs.addChildren.toggle()
      let len = !this.travelerList ? 0 : this.travelerList.length
      if(len == 5) {
        this.$dialog.alert({ message: '火车票一次预订，最多订5人！' })
        return false
      } else {
        let child = {
          psgType: '2', //  乘车人类型1、成人；2儿童 ,
          ticketType: '2', //  车票类型 1成人票 2儿童票 3学生票 4残军票
          empName: this.$options.filters.getName(psg),
          name: this.$options.filters.getName(psg)
        }
        this.travelerList.splice(i + 1, 0, child)
        this.$store.commit('tr/travelerList', this.travelerList)
      }
    },
    // 删除乘车人
    deletePsg(index, curPsg) {
      this.travelerList.splice(index, 1)

      if (curPsg) {
        this.trSearchInfo['12306Info'].psgList.forEach(psg => {
          if (psg.name == curPsg.name) {
            psg.checked = false
          }
        })
      }

      /**
       * 当一个成人添加了儿童，删除成人后，关联的儿童也要自动删除
       */
      if (curPsg && (curPsg.psgType == 1 || !curPsg.psgType)) {
        this.travelerList = this.travelerList.filter((psg) => {
          return !(curPsg.name === psg.empName && psg.psgType === '2')
        })
      }

      this.$store.commit('tr/travelerList', this.travelerList)
      this.$emit('match-clzc')
    },
    toggle() {
      this.isShow = !this.isShow
    }
  },
  computed: {
    ...mapGetters({
      trSearchInfo: 'tr/trSearchInfo',
    })
  },
  filters: {
    passengerType (val) {
      if (val == 2) {
        return '儿童'
      } else {
        return '成人'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.traver12306 {
  .traver12306-hd {
    .van-cell__value {
      flex: 2;
    }
  }

  .addCxr {
    display: inline-block;
    padding: 0px 10px;
    border-radius: 15px;
    text-align: center;
    font-size: @font-size-14;
    border-width: 1px;
    border-style: solid;
  }

  .traveler-item {
    width: 100%;
    padding: 10px 0 10px 15px;
    background-color: @color-background-white;

    .delete {
      width: 35px;
    }
    
    .info {
      width: calc(100% - 86px);
    }

    .edit {
      width: 45px;
      margin-left: 5px;
    }
  }

  .van-tag {
    vertical-align: text-bottom
  }
}
</style>
